
import PropTypes from 'prop-types'
import React from 'react'
import className from 'classnames'
import ShowHide from './ShowHide'
import './Alert.css'

/**
 * Exports.
 */

const Alert = props => {
  const { children, type, title, ctaUrl, ctaText, ctaTarget, onCtaClick } = props
  let { noIcon } = props

  if (type === 'default') {
    noIcon = true
  }

  const classes = className({
    Alert: true,
    [`Alert--${type}`]: true,
    'Alert--no-icon': noIcon
  })

  let role = 'status'
  if (type === 'danger' || type === 'warning' || type === 'success') {
    role = 'alert'
  }

  return (
    <div role={role} className={classes}>
      <div className='Alert-text'>
        <ShowHide show={title}>
          <div className='Alert-title'>{title}</div>
        </ShowHide>

        <div className='Alert-body'>{children}</div>
      </div>

      <ShowHide show={ctaText}>
        <a className='Alert-cta' href={ctaUrl} rel='external' target={ctaTarget} onClick={onCtaClick}>{ctaText}</a>
      </ShowHide>
    </div>
  )
}

Alert.defaultProps = {
  type: 'default'
}

Alert.propTypes = {
  children: PropTypes.node,
  ctaTarget: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  noIcon: PropTypes.bool,
  onCtaClick: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.string.isRequired
}

Alert.displayName = 'Alert'

export default Alert



// WEBPACK FOOTER //
// ./ui/Alert.js